import http from "../plugins/http";

export const fetchCities = async ({ id_state, query = "&all=1" }: { id_state: number; query?: string }) => {
  const data = await http.get(`/v1/public/cities?id_state=${id_state}${query}`)
  return data
}

